'use client';
import { Auth, onAuthStateChanged, User } from 'firebase/auth';
import { useState, useEffect } from 'react';
import { useAuth } from '../provider';

// TODO(studio): Unify auth and firestore offline/online state
export function useUser() {
  const auth = useAuth();
  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (auth) {
      const unsubscribe = onAuthStateChanged(
        auth,
        (user) => {
          setUser(user);
          setIsLoading(false);
        },
        (error) => {
          setError(error);
          setIsLoading(false);
        }
      );
      return () => unsubscribe();
    } else {
      setIsLoading(false);
    }
  }, [auth]);

  return { user, isLoading, error };
}
